import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { SocketIoModule } from 'ngx-socket-io';
//* Permissions Android
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
//* Project Imports
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AppRoutes } from './app.routing';
import { SharedModule } from './shared/shared.module';

//* Translate
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LoadTranslateJSON } from './utils/supplies.utils';

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
    }),
    NgbModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader : {
        provide: TranslateLoader,
        useFactory: (LoadTranslateJSON),
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
      preventDuplicates: false
    }), // ? ToastrModule added
    SharedModule,
    SocketIoModule
  ],
  providers: [
    AndroidPermissions
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
